import React from "react";
import { Grid, Box } from "@material-ui/core";

const VideoContainer = ({ classes, videoGraphic, videoButton, isMobile, isBrowser }) => {
  return (
    <Grid container className={classes.videoContainer}>
      <Grid item md={6} className={classes.videoGrid}>
        <Box className={classes.videoBox}>
          <a
            className="no-border html5lightbox match-video"
            data-autoplayvideo="true"
            data-fancybox="true"
            href="https://youtu.be/KLMBaK1KxIU?autoplay=1"
            data-width="960"
            data-height="540"
            samesite="none"
  > 
  <figure style={{ margin: "0" }} className="image-over">
              <img
                src={videoGraphic}
                className={`${classes.imgFluid} ${classes.boys}`}
                // className="img-fluid boy-water"
                alt="GivePower Water"
              />
            </figure>
            <div className="clearfix" />
          </a>
        </Box>
      </Grid>
      <Grid item md={6} className={classes.textGrid}>
        <Box className={classes.textBox}>
          <Box className={`${classes.lead} ${classes.whiteText}`}>
          CAN YOU IMAGINE A WORLD WITHOUT WATER FOR EVEN A FEW HOURS?
          </Box>

          <Box className={`${classes.paragraphSmaller} ${classes.whiteText}`}>
          Only 1/6th of earth’s fresh water is accessible. GivePower is on 
          a mission to provide clean drinking water for the countless people 
          around the world who lack affordable, safe, and reliable access. 
          This video shines a light on the GivePower team providing a sustainable
           source of fresh water to communities in need through the use of innovative technology.
          </Box>
          <Box className={classes.paragraph}>
          <a
            className="no-border html5lightbox match-video"
            data-autoplayvideo="true"
            data-fancybox="true"
            href="https://youtu.be/KLMBaK1KxIU?autoplay=1"
            data-width="960"
            data-height="540"
            samesite="none"
  > 
            <img
              src={videoButton}
              alt="Video Button"
            />
            </a>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default VideoContainer;
